import Cookies from 'js-cookie'
import Session from "./Session";
import {BACKEND} from "./business/Constants";
export const COOKIE_TOKEN_KW = '_token';
export const DEFAULT_CONFIG = {
    backend: BACKEND,
    decoder: p=>p.json(),
    parser: null,
};

function process(packet)
{
    let status = packet.status;
    let output = packet.output;
    let is_in  = packet.in;

    if(packet.token) Cookies.set(COOKIE_TOKEN_KW, packet.token);

    try{

        if(!is_in && Session.in()){
            Session.logout();
            location.reload();
            throw 'Session expired';
        }
        if(status!==200)throw 'Server Error';

    }catch(err){
        console.error(err, packet);
        throw err;
    }
    return output;
}


export function API_UPLOAD(action, file, config){
    config = {...DEFAULT_CONFIG, ...(config||{})};
    return new Promise(function(resolve, reject){
        let xhr = new XMLHttpRequest();
        xhr.upload.onprogress = function(event) {
            let percent = Math.round(100 * event.loaded / event.total);
            if(config.progress) config.progress(percent);
        };
        xhr.upload.onerror = function() {
            reject(xhr.status);
        };
        xhr.onload = function() {
            resolve();
        };

        let fd = new FormData();
        fd.append('file', file);
        fd.append('action', action);
        xhr.open('POST', config.backend);
        xhr.setRequestHeader('Authorization','Token '+(Cookies.get(COOKIE_TOKEN_KW)||'none'));
        xhr.send(fd);
    });
}

export default function API(action, opt, config){
    config = {...DEFAULT_CONFIG, ...(config||{})};
    return new Promise(function(resolve, reject){
        console.log("-> OUT", {IN: (Cookies.get(COOKIE_TOKEN_KW)||'none')}, {action:action, payload: opt});
        fetch(config.backend, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Token '+(Cookies.get(COOKIE_TOKEN_KW)||'none')
            },
            //credentials: 'include',
            body: JSON.stringify({action:action, payload: opt})
        })
            .then(config.decoder)
            .then(function(packet){

                console.log("<- IN", packet);

                if(config.parser){
                    try{
                        resolve(config.parser(packet));
                    }catch(e){reject(e); throw e; };
                    return;
                }

                try {
                    resolve(process(packet));
                }catch(e){
                    reject(e);
                    throw e;
                }
            })
            .catch(reject)
        ;
    });
}